export enum EcPaymentEnums {
  getExpireAlertList = 'ECPayment/ExpireAlertList', // 取得即將過期的機台清單
  getPaymentRecords = 'ECPayment/PaymentRecords', // 取得付款紀錄
  getPaymentRecordDetail = 'ECPayment/PaymentRecordDetail', // 取得付款紀錄詳細資料
  getPlanSelections = 'ECPayment/PlanSelections', // 取得付費方案清單
  getPaymentDetails = 'ECPayment/PaymentDetails', // 取得機台付款清單
  getPaymentConfirmInfos = 'ECPayment/PaymentConfirmInfos', // 取得付款確認頁內容
  sendEcPayment = 'ECPayment/ECPayment' // 送出金流資訊
}
